export default {
    Metadata: {
        Name: "Rnd",
        Description: "Returns a pseudo-random decimal from 0 and up to but not including 1.",
        Syntax: "Rnd()",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute() {
        return Math.random();
    },
};

